import { render, staticRenderFns } from "./AddAlternateMedia.vue?vue&type=template&id=9777bb9c&scoped=true&"
import script from "./AddAlternateMedia.vue?vue&type=script&lang=js&"
export * from "./AddAlternateMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9777bb9c",
  null
  
)

export default component.exports